<script lang="ts">
  import { onMount } from 'svelte';
  import { userStore, uiState, setUIState, setSearch, setSearchByPermission, setSorting } from '$lib/stores/userStore';
  import NoUserPage from '$lib/components/drawers/client/edit/tabs/components/NoUserPage.svelte';
  import AddNewUserPage from '$lib/components/drawers/client/edit/tabs/components/AddNewUserPage.svelte';
  import DataTable from '$lib/components/drawers/client/edit/tabs/components/UserDataTable.svelte';
  import UpdateUserPage from '$lib/components/drawers/client/edit/tabs/components/UpdateUserPage.svelte';
  import SearchBox from '$lib/components/common/searchBox/SearchBox.svelte';
  import Checkbox from '$lib/components/common/checkbox/Checkbox.svelte';
  import SortButton, { type ListItem } from '$lib/components/common/sortButton/SortButton.svelte';
  import { ColumnNames } from '$lib/models/user/types';
  import { Icons } from '$lib/components/common/icon';
  import { fade } from 'svelte/transition';

  export let clientId: number;

  let selectedUserId: number | null = null;
  let searchValue = '';
  $: searchValue, setSearch(searchValue);
  
  let searchByPermission = false;
  $: searchByPermission, setSearchByPermission(searchByPermission);
  
  let sortBy: 'asc' | 'desc' = 'asc';
  let orderBy: string = 'Name';
  $: sortBy, setSorting(sortBy, orderBy);
  let sortOptions: ListItem[] = [
    {
      icon: Icons['arrow-up'],
      displayName: 'User Name',
      orderBy: ColumnNames.Name,
      sortBy: 'asc',
    },
    {
      icon: Icons['arrow-down'],
      displayName: 'User Name',
      orderBy: ColumnNames.Name,
      sortBy: 'desc',
    },
    {
      icon: Icons['arrow-up'],
      displayName: 'Email',
      orderBy: ColumnNames.Email,
      sortBy: 'asc',
    },
    {
      icon: Icons['arrow-down'],
      displayName: 'Email',
      orderBy: ColumnNames.Email,
      sortBy: 'desc',
    },
    {
      icon: Icons['arrow-up'],
      displayName: 'Permission',
      orderBy: ColumnNames.Permission,
      sortBy: 'asc',
    },
    {
      icon: Icons['arrow-down'],
      displayName: 'Permission',
      orderBy: ColumnNames.Permission,
      sortBy: 'desc',
    },
  ];

  onMount(async () => {
    const userCount = await userStore.count(clientId);
    setUIState(userCount > 0 ? 'DataTable' : 'NoUserPage');
  });
  
  function onSearchByClick(a) {
    searchByPermission = !searchByPermission;
  }
  
  function onItemSelect(orderBy: string, sortBy: 'asc' | 'desc') {
    setSorting(sortBy, orderBy);
  }

</script>

{#if $uiState === 'AddUserPage'}
  <div in:fade>
    <AddNewUserPage bind:clientId />
  </div>
{:else if $uiState === 'DataTable'}
  <div in:fade>
      <div class="flex flex-col place-content-between gap-5 xl:flex-row xl:gap-0">
          <span class="whitespace-nowrap text-sm font-medium text-black">Search users for the client</span>
          <div class="flex flex-col gap-3">
              <div class="flex flex-row flex-wrap gap-3 xl:place-content-end">
                <SearchBox bind:value={searchValue} isExpandable={true} />
                <Checkbox checked={searchByPermission} label={'Search by Permission'} onClick={() => onSearchByClick()} />
                <SortButton bind:orderBy bind:sortBy onButtonClick={() => function () {}} {onItemSelect} items={sortOptions} />
              </div>
          </div>
      </div>
      <hr class="divider my-5" />
      <DataTable bind:clientId />
  </div>
{:else if $uiState === 'UpdateUserPage'}
  <div in:fade>
    <UpdateUserPage {clientId} on:userUpdated={() => setUIState('DataTable')} />
  </div>
{:else if $uiState === 'NoUserPage'}
  <div in:fade>
    <NoUserPage on:addUserClick={() => setUIState('AddUserPage')} />
  </div>
{/if}
